import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetCheckinEntryDetailDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { checkinEntryProfileDrawerState } from '~/state/reception/atoms';

export const useFetchCheckinEntry = () => {
  const { isOpen, checkinEntryId } = useAtomValue(checkinEntryProfileDrawerState);

  const [getCheckin, { data, loading }] = useLazyQuery(GetCheckinEntryDetailDocument, {
    fetchPolicy: 'network-only',
  });

  const checkinEntry = getNode(data, 'CheckinEntry');

  useEffect(() => {
    if (isOpen && checkinEntryId) {
      getCheckin({
        variables: {
          id: checkinEntryId,
        },
      });
    }
  }, [getCheckin, isOpen, checkinEntryId]);

  return { checkinEntry, loading };
};
